// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"372":"72387292","670":"8c5e8886","734":"6b19e169"}[chunkId] + ".js";
};